import React from 'react';
import { Outlet } from 'react-router-dom';

interface PageContainerProps {
  className: string;
}

export const PageContainer = ({ children, className }: React.PropsWithChildren<PageContainerProps>) => {
  return (
    <div className="grid grid-cols-12 p-6 mb-12">
      <div className={className}>
        <Outlet />
        {children}
      </div>
    </div>
  );
};
